import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { Dispatch, GetState } from '../../../../../model/State';
import validateEmailAddress from '../../../../../util/email';
import { fetchGetCustomerByEmail } from '../contact';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    // return
  }
  const alternateUser = getState().location?.query?.alternateUser;

  if (alternateUser && !!validateEmailAddress(decodeURIComponent(alternateUser))) {
    dispatch(fetchGetCustomerByEmail(decodeURIComponent(alternateUser)));
  }
};
